// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__6xDCX","left":"InfoRow_left__bAkJb"};